import { SxProps, Theme } from '@mui/material';

export const compactCardContentSx: SxProps<Theme> = { p: 2, '&:last-child': { pb: 2 } };
